import clsx from 'clsx';
import { __ } from '@wordpress/i18n';
import { forwardRef } from '@wordpress/element';
import styles from './style.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UnforwardedProgressBar(props, ref) {
  const {
    className,
    value,
    ...progressProps
  } = props;
  const isIndeterminate = !Number.isFinite(value);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.track, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(styles.indicator, {
        [styles['is-indeterminate']]: isIndeterminate
      }),
      style: {
        '--indicator-width': !isIndeterminate ? `${value}%` : undefined
      }
    }), /*#__PURE__*/_jsx("progress", {
      className: styles['progress-element'],
      max: 100,
      value: value,
      "aria-label": __('Loading …'),
      ref: ref,
      ...progressProps
    })]
  });
}

/**
 * A simple horizontal progress bar component.
 *
 * Supports two modes: determinate and indeterminate. A progress bar is determinate
 * when a specific progress value has been specified (from 0 to 100), and indeterminate
 * when a value hasn't been specified.
 *
 * ```jsx
 * import { ProgressBar } from '@wordpress/components';
 *
 * const MyLoadingComponent = () => {
 * 	return <ProgressBar />;
 * };
 * ```
 */
export const ProgressBar = forwardRef(UnforwardedProgressBar);
ProgressBar.displayName = 'ProgressBar';
export default ProgressBar;